import {axios} from '../../utils/request'
import path from '../../api/path'

export function getViewDetail(uuid) {
    const url = '/' + path.apiName + path.php + '/shipment-handing/detail/' + uuid
    return axios({
        url: url,
        method: 'get'
    })
}

export function feedBack(type, params) {
    var url = ''
    if (path.apiName === 'ltt') {
        url = '/' + path.apiName + '/carrier-case/' + type + '/feedback'
    } else {
        url = '/' + path.apiName + '/carrier-case/' + type + '/feedback'
    }
    return axios({
        url: url,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        redirect: 'follow'
    })
}
